import {BaseModel} from '../baseModel';
import {Partner} from '../res/partner';
import {State} from '../res/state';
import {Country} from '../res/country';
import {MedicalSpecialty} from './MedicalSpecialty';
import {SpokenLanguage} from '../res/spoken-language';
import {FacilityProgram} from './FacilityProgram';
import {SurveyorSurveyType} from '../../enums/survey/SurveyorSurveyType';
import {CertifyingBoard} from './CertifyingBoard';
import {MemberBoard} from './MemberBoard';
import {OwnerType} from '../../enums/common/owner-type.enum';
import {LicenseInfo} from './LicenseInfo';

export class Assignee extends BaseModel<number> {
  licenseNumber: string;
  countryIssued: Country;
  stateIssued: State;
  yearIssued: number;
  yearCertified: number;
  certifyingBoard: CertifyingBoard;
  memberBoard: MemberBoard;
  expirationDate: Date;
  effectiveDate: Date;
  specialties: MedicalSpecialty[];
  notes: string;
  spokenLanguages: SpokenLanguage[];
  facilityPrograms: FacilityProgram[];
  surveyorSurveyTypes: SurveyorSurveyType[];
  assignments: any[];
  partner: Partner;
  ownerType?: OwnerType;
  licenses?: LicenseInfo[] = [];
  isQuadAEmployee?: boolean;
}
